// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__F2tOK","bar":"Loading_bar__Ujf-P","loading":"Loading_loading__ja9R+","text":"Loading_text__5TDBG"};